import { FormControl } from '@angular/forms';

export function minLengthIfOther(
    otherControlName: string,
    otherControlValue: any | any[],
    minLength: number = 1
) {
    let thisControl: FormControl;
    let otherControl: FormControl;

    return function minLengthIfOtherValidate(control: FormControl) {
        if (!control.parent) {
            return null;
        }

        // Initializing the validator.
        if (!thisControl) {
            thisControl = control;
            otherControl = control.parent.get(otherControlName) as FormControl;
            if (!otherControl) {
                throw new Error(
                    'minLengthIfOther(): other control is not found in parent group'
                );
            }
            otherControl.valueChanges.subscribe(() => {
                thisControl.updateValueAndValidity();
            });
        }

        if (!otherControl) {
            return null;
        }

        if (Array.isArray(otherControlValue)) {
            if (
                otherControlValue.includes(otherControl.value) &&
                !thisControl.value
            ) {
                return {
                    required: true,
                };
            }
        } else {
            if (
                otherControl.value === otherControlValue &&
                (!thisControl.value || thisControl.value.length < minLength)
            ) {
                return {
                    required: true,
                };
            }
        }

        return null;
    };
}
